import { useSelector } from 'react-redux';
import React from 'react';

import { FjFlexContainer } from 'components/primitives';
import Loading from 'components/loading';
import AlertUi, { AlertStore } from '../alert-ui';
import ManageUsers from './tab-content-area/selected-tab-content/manage-users';
import NewUsers from './tab-content-area/selected-tab-content/new-users';
import NewSharedComputerModal from './tab-content-area/selected-tab-content/shared-computer/new-shared-computer-modal';
import NewFacsWorkflowManagerLicenseModal from './tab-content-area/selected-tab-content/facs-workflow-manager-license/new-license-modal';
import TabContentArea from './tab-content-area';
import AdminToolArea from './admin-tool-area';
import { userAdminSelector, cloudAdminSelector } from '../../selectors';

interface CloudAdminModals {
  feature?: string | null;
}

interface CloudAdminState {
  modals: CloudAdminModals;
}

interface UserAdminState {
  costCenter?: unknown;
  adminCostCenterList: Record<string, { productAccess: { name: string }[] }>;
}

interface CloudAdminProps {
  store?: AlertStore;
}

const CloudAdmin = ({ store }: CloudAdminProps): React.ReactElement => {
  const cloudAdminState = useSelector(cloudAdminSelector) as CloudAdminState;
  const userAdminState = useSelector(userAdminSelector) as UserAdminState;

  const renderDialog = (): React.ReactElement | null => {
    const { feature } = cloudAdminState.modals;
    if (feature === 'add-users') {
      return <NewUsers />;
    }
    if (feature === 'manage-users') {
      return <ManageUsers />;
    }
    if (feature === 'add-shared-computers') {
      return <NewSharedComputerModal />;
    }
    if (feature === 'add-facs-workflow-manager-license') {
      return <NewFacsWorkflowManagerLicenseModal />;
    }
    return null;
  };

  if (!userAdminState?.costCenter) {
    return <Loading />;
  }

  return (
    <FjFlexContainer>
      {/* TODO: do we need this AlertUi component? */}
      <AlertUi store={store as AlertStore} />
      <FjFlexContainer>
        <AdminToolArea />
        <TabContentArea userAdminState={userAdminState} />
        {renderDialog()}
      </FjFlexContainer>
    </FjFlexContainer>
  );
};

export default CloudAdmin;
